import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Constants } from '@app/constants';
import { getContext } from '@app/core';

@Injectable({ providedIn: 'root' })
export class MessengerService {
  constructor(public http: HttpClient) {
  }

  getToken(identity: string, accountSid: string) {
    return this.http.disableLoader().post(
      Constants.APIS.MESSENGER.GET_TOKEN,
      {
        Identity: identity,
        AccountSid: accountSid,
      },
      { context: getContext('messenger') }
    );
  }
  getTwilioSettings() {
    return this.http
      .disableLoader()
      .get(Constants.APIS.MESSENGER.TWILIO_SETTINGS, { context: getContext('messenger') });
  }
}
